/** Width/layout constants for the session-tools drawer (mirrors AI assistant drawer). */

export const SESSION_TOOLS_WIDTH_STORAGE_KEY = 'unify.sessionTools.drawerWidth';

export const SESSION_TOOLS_DEFAULT_WIDTH = 430;
export const SESSION_TOOLS_MIN_WIDTH = 340;
export const SESSION_TOOLS_MAX_WIDTH = 720;
export const SESSION_TOOLS_MAX_RATIO = 0.55;

/** Matches App.tsx / AI assistant mobile shell breakpoint. */
export const SESSION_TOOLS_MOBILE_MEDIA_QUERY = '(max-width: 48em)';

export function clampSessionToolsWidth(width: number, availableMainWidth: number): number {
  const maxByRatio = Math.floor(availableMainWidth * SESSION_TOOLS_MAX_RATIO);
  const max = Math.max(
    SESSION_TOOLS_MIN_WIDTH,
    Math.min(SESSION_TOOLS_MAX_WIDTH, maxByRatio || SESSION_TOOLS_MAX_WIDTH),
  );
  return Math.min(max, Math.max(SESSION_TOOLS_MIN_WIDTH, Math.round(width)));
}

export function readStoredSessionToolsWidth(): number {
  try {
    const raw = window.localStorage.getItem(SESSION_TOOLS_WIDTH_STORAGE_KEY);
    if (!raw) return SESSION_TOOLS_DEFAULT_WIDTH;
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) return SESSION_TOOLS_DEFAULT_WIDTH;
    return clampSessionToolsWidth(parsed, Number.POSITIVE_INFINITY);
  } catch {
    return SESSION_TOOLS_DEFAULT_WIDTH;
  }
}

export function persistSessionToolsWidth(width: number): void {
  try {
    window.localStorage.setItem(SESSION_TOOLS_WIDTH_STORAGE_KEY, String(Math.round(width)));
  } catch {
    // Ignore quota / private-mode failures; width stays in memory.
  }
}
